import React, { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';
import { Panel } from './ApplicantHeader';
import { useHiringApi, errMsg } from './useHiringApi';
import { fmtDateTime } from './hiringConstants';

const describe = (ev) => {
  const d = ev.details || {};
  switch (ev.action) {
    case 'application_submitted': return 'Application submitted from the website';
    case 'applicant_added_manually': return `Added manually (${d.inquiry_channel || 'inquiry'})`;
    case 'stage_changed': return `Stage: ${d.from} → ${d.to}${d.reason ? ` — ${d.reason}` : ''}`;
    case 'assignment_updated': return `Assignment updated${d.owner ? ` · owner ${d.owner}` : ''}${d.next_action?.text ? ` · next: ${d.next_action.text}` : ''}`;
    case 'note_added': return 'Note added';
    case 'interview_recorded': return `Interview recorded (${d.outcome || 'scheduled'})`;
    case 'interview_updated': return 'Interview updated';
    case 'trial_clean_updated': return 'Trial clean updated';
    case 'offer_updated': return `Offer ${d.status || 'updated'}`;
    case 'decision_recorded': return `Decision: ${d.outcome}`;
    case 'resume_downloaded': return `Résumé downloaded (${d.filename})`;
    case 'converted_to_guru': return 'Guru account created from this applicant';
    default: return ev.action.startsWith('message_') ? `Email ${ev.action.replace('message_', '').replace('_', ' ')}: ${d.subject || d.kind}` : ev.action;
  }
};

export default function ApplicantNotes({ a, onUpdated }) {
  const api = useHiringApi();
  const [note, setNote] = useState('');
  const add = async (e) => {
    e.preventDefault();
    if (!note.trim()) return;
    try { onUpdated(await api.note(a.id, note.trim())); setNote(''); toast.success('Note added'); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <>
      <Panel title="Notes" testId="notes-panel">
        <form onSubmit={add} className="space-y-2">
          <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Add an internal note…" data-testid="note-input" />
          <div className="flex justify-end"><Button className="bg-orange-600 hover:bg-orange-700 text-white" type="submit" size="sm" disabled={!note.trim()} data-testid="note-add">Add note</Button></div>
        </form>
        <ul className="space-y-2" data-testid="notes-list">
          {[...(a.notes || [])].reverse().map((n) => (
            <li key={n.id} className="bg-zinc-50 rounded-lg p-3 text-sm" data-testid={`note-${n.id}`}>
              <p className="whitespace-pre-wrap text-zinc-800">{n.body}</p>
              <p className="text-[11px] text-zinc-500 mt-1">{n.actor_name} · {fmtDateTime(n.created_at)}</p>
            </li>
          ))}
        </ul>
      </Panel>
      <Panel title="Activity history" testId="activity-panel">
        <ol className="space-y-2 text-xs" data-testid="activity-list">
          {[...(a.activity || [])].reverse().map((ev) => (
            <li key={ev.id} className="flex gap-2">
              <span className="text-zinc-400 whitespace-nowrap">{fmtDateTime(ev.at)}</span>
              <span className="text-zinc-800"><b>{ev.actor_name}</b> — {describe(ev)}</span>
            </li>
          ))}
        </ol>
      </Panel>
    </>
  );
}
